import React from 'react'
import ImageCardDisplay from '../imageCardDisplay'
import AddInspirationFromWrap from '../addInspirationFromWrap'
import './index.less'

export default ({
  onFormChange,
  formParams, //
  mode,
  blogList,
  platformId,
  currentViewBlog,
  onImageChange,
  hasCurInstated,
}) => {
  const {
    imageGroupEntityId,
    mainUrl,
    picUrl,
    inspirationId,
    colorId,
  } = currentViewBlog || {}

  const listWidth = 420
  return <div className="add-inspiration-info" style={{ width: listWidth }}>
    <AddInspirationFromWrap
      formParams={formParams}
      onFormChange={onFormChange}
      listWidth={listWidth}
    >
      <ImageCardDisplay
        hasCurInstated={hasCurInstated}
        imageNum={blogList.length}
        blogId={imageGroupEntityId}
        platformId={platformId}
        blogList={blogList}
        mode={mode}
        colorId={colorId}
        inspirationId={inspirationId}
        picUrl={picUrl}
        mainUrl={mainUrl}
        onChange={onImageChange}
      />
    </AddInspirationFromWrap>
  </div>
}
